import React from 'react';
import { Tooltip } from 'antd';
import '@/assets/less/ellipsis-text.less';

const EllipsisText = ({ 
  children, 
  tooltip = true, 
  className = '', 
  style = {}, 
  lines = 1,
  onClick = null,
  forceCapitalize = false
}) => {
  const ellipsisStyle = lines > 1
    ? {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        overflow: 'hidden',
        whiteSpace: 'normal',
        textTransform: forceCapitalize ? 'uppercase' : 'none',
        ...style,
      }
    : {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: forceCapitalize ? 'uppercase' : 'none',
        ...style,
      };
  
  const content = (
    <div
      className={`ellipsis-text ${className}`}
      style={ellipsisStyle}
      onClick={onClick}
    >
      {children}
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip title={
        <span onContextMenu={(e) => {e.preventDefault(); e.stopPropagation();}}>
        {children}
        </span>
      }
      mouseLeaveDelay={0.3}>
        <span
          onContextMenu={(e) => {e.preventDefault(); e.stopPropagation()}}
        >
              {content}
        </span>
      </Tooltip>
    );
  }
  
  return content;
};

export default React.memo(EllipsisText);
